import { useState } from 'react';

import { AddressFieldsContainer } from './AddressFieldsContainer';
import { AddressFormSeparateContainer } from './AddressFormSeparateContainer';

// TODO: Fix this the next time the file is edited.
// oxlint-disable-next-line typescript/no-explicit-any
export function AddressFormSeparateFieldsSwitch(props: Record<string, any>) {
  const [separateFields, setSeparateFields] = useState(false);

  const toggleSeparateFields = () => setSeparateFields((s) => !s);

  return separateFields ? (
    <AddressFormSeparateContainer
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      toggleSeparateFields={toggleSeparateFields}
    />
  ) : (
    <AddressFieldsContainer
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      toggleSeparateFields={toggleSeparateFields}
    />
  );
}
